import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Flex } from "../../../../components/Flex";
import { Text } from "../../../../components/Text";
import { Rounded } from "../../../../theme/Rounded";
import { Spacing } from "../../../../theme/Spacing";

const Pill = styled(Flex)`
  align-self: center;
  align-items: center;
  padding: ${Spacing.xs} ${Spacing.m};
  margin: ${Spacing.m} 0 ${Spacing.s};
  border-radius: ${Rounded.pill};
  background-color: ${({ theme }) => theme.sub};
  position: sticky;
  top: ${Spacing.s};
  z-index: 1;
`;

type Props = {
  timestamp: string;
};

export const WADateSeparator: React.FC<Props> = ({ timestamp }) => {
  const { t } = useTranslation();

  const date = dayjs(Number(timestamp) * 1000);
  const today = dayjs();

  const label = date.isSame(today, "day")
    ? t("common.today")
    : date.isSame(today.subtract(1, "day"), "day")
      ? t("common.yesterday")
      : date.isSame(today, "year")
        ? date.format("D MMMM")
        : date.format("D MMMM YYYY");

  return (
    <Pill>
      <Text fontSize="xs" color="darkerSub" fontWeight="bold">
        {label}
      </Text>
    </Pill>
  );
};
